
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/[slug]",
      function () {
        return require("private-next-pages/reports/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/[slug]"])
      });
    }
  